import { FiCopy } from "react-icons/fi";
export { FiCopy };

export const handleCopy = (text: any, setCopy?: any) => {
  navigator.clipboard.writeText(text);
  if (navigator.clipboard.writeText(text)) {
    if (setCopy) {
      setCopy(true);
    }
  }
};
